import { render, staticRenderFns } from "./TableModel.vue?vue&type=template&id=f2067212&scoped=true&"
import script from "./TableModel.vue?vue&type=script&lang=js&"
export * from "./TableModel.vue?vue&type=script&lang=js&"
import style0 from "./TableModel.vue?vue&type=style&index=0&id=f2067212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2067212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VFlex,VLayout})
